import styled from 'styled-components'
import { Checkbox } from 'antd'
import { secondaryTextColor, greenPrimary } from '@edulastic/colors'

export const PointsLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: ${secondaryTextColor};
  text-align: center;
  margin-right: 0;
  margin-bottom: 8px;
`

export const QuestionIndex = styled.span`
  display: block;
  margin-right: 0;
  font-size: 12px;
  font-weight: 600;
  color: ${secondaryTextColor};
  cursor: grab;
`

export const QuestionCheckbox = styled(Checkbox)`
  display: block;
  margin-top: 10px;

  .ant-checkbox-inner {
    width: 18px;
    height: 18px;
  }
`
export const AIReviewContainer = styled.div`
  margin-left: ${(props) => props.marginLeft || '65px'};

  & .ant-btn {
    color: ${greenPrimary};
    border: none;
    padding-right: 3px;
    padding-left: 3px;
    margin-right: 7px;
    margin-left: 7px;
    text-transform: uppercase;
    font-weight: bold;

    &.ant-btn-loading {
      padding-right: 3px;
      padding-left: 3px;
      margin-right: 7px;
      margin-left: 7px;
    }

    &:hover {
      color: ${greenPrimary};
    }

    &:active {
      color: ${greenPrimary};
    }

    &:focus {
      color: ${greenPrimary};
      border: 1px solid ${greenPrimary};
    }

    & svg {
      color: ${greenPrimary};
      margin-right: 5px;
    }
  }
`
